import { render, staticRenderFns } from "./MatchingPhonics2.vue?vue&type=template&id=6a9d272f&scoped=true&"
import script from "./MatchingPhonics2.vue?vue&type=script&lang=js&"
export * from "./MatchingPhonics2.vue?vue&type=script&lang=js&"
import style0 from "./MatchingPhonics2.vue?vue&type=style&index=0&id=6a9d272f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d272f",
  null
  
)

export default component.exports